import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';
import { debounceTime, fromEvent, tap } from 'rxjs';

const DEBOUNCE_PATTERN = /^([a-z]+)\.debounce\.(\d+)(ms|s)$/i;

export class DebounceEventPlugin extends EventManagerPlugin {
  constructor() {
    super(inject(DOCUMENT));
  }

  public override supports(eventName: string): boolean {
    return DEBOUNCE_PATTERN.test(eventName);
  }

  public override addEventListener(
    element: HTMLElement,
    eventName: string,
    handler: (event: Event) => void,
  ): () => void {
    const match = eventName.match(DEBOUNCE_PATTERN)!;
    const baseEvent = match[1];
    const wait = match[3].toLowerCase() === 's' ? Number(match[2]) * 1000 : Number(match[2]);
    const zone = this.manager.getZone();

    const subscription = zone.runOutsideAngular(() =>
      fromEvent<Event>(element, baseEvent)
        .pipe(
          tap((event) => {
            event.preventDefault();
            event.stopPropagation();
          }),
          debounceTime(wait),
        )
        .subscribe((event) => zone.runGuarded(() => handler(event))),
    );

    return () => subscription.unsubscribe();
  }
}
